var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakePurchase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66393 5.33332H8.99726V3.33333H10.9973V2H8.99726V0H7.66393V2H5.66393V3.33333H7.66393V5.33332ZM4.99792 11.3331C4.26459 11.3331 3.67126 11.9331 3.67126 12.6664C3.67126 13.3998 4.26459 13.9998 4.99792 13.9998C5.73126 13.9998 6.33125 13.3998 6.33125 12.6664C6.33125 11.9331 5.73126 11.3331 4.99792 11.3331ZM11.6629 11.3331C10.9296 11.3331 10.3363 11.9331 10.3363 12.6664C10.3363 13.3998 10.9296 13.9998 11.6629 13.9998C12.3963 13.9998 12.9963 13.3998 12.9963 12.6664C12.9963 11.9331 12.3963 11.3331 11.6629 11.3331ZM5.11174 9.16648L5.13174 9.08649L5.73174 7.99982H10.6984C11.1984 7.99982 11.6384 7.72649 11.8651 7.31316L14.4384 2.63983L13.2784 1.99983H13.2717L12.5384 3.33316L10.6984 6.66649H6.0184L5.93174 6.48649L4.43841 3.33316L3.80507 1.99983L3.17841 0.666503H0.998413V1.99983H2.33174L4.73174 7.05982L3.83174 8.69315C3.72507 8.87982 3.66507 9.09982 3.66507 9.33315C3.66507 10.0665 4.26507 10.6665 4.9984 10.6665H12.9984V9.33315H5.2784C5.19174 9.33315 5.11174 9.25982 5.11174 9.16648Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakePurchase);
export default __webpack_public_path__ + "static/media/MakePurchase.3105295bd22dec4a43a45a062af5235a.svg";
export { ForwardRef as ReactComponent };